export default __webpack_public_path__ + "img/quotes.c18222c9.svg";